import { useActionState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { userService } from '../../apiServices/UserService';
import Alert, { AlertType } from '../../components/Alert/Alert';
import Button, { ButtonType } from '../../components/Button/Button';
import { siteConfig } from '../../config/siteConfig';
import './Login.css';

type LoginState = {
  alert?: AlertType;
};

function Login() {
  const intl = useIntl();

  async function loginAction(
    _prevState: LoginState,
    formData: FormData
  ): Promise<LoginState> {
    const email = formData.get('email') as string;

    try {
      const { message } = await userService.signIn(email);
      return { alert: { message, type: 'success' } };
    } catch (error) {
      return {
        alert: {
          message:
            error instanceof Error
              ? error.message
              : intl.formatMessage({ id: 'login.error' }),
          type: 'error',
        },
      };
    }
  }

  const [state, formAction, isPending] = useActionState(loginAction, {});

  return (
    <div className={'login'}>
      <a href={`https://${siteConfig.domain}`} target="_blank">
        <img className="logo" src={siteConfig.logoSrc} alt="" />
      </a>

      <div className="input-form">
        <h1 className="info">
          <FormattedMessage id="login.heading" />
        </h1>
        <form action={formAction}>
          <div className="email-container">
            <label className="login-label" htmlFor="email">
              <FormattedMessage id="login.emailLabel" />
            </label>
            <input
              id="email"
              name="email"
              className="email-input"
              type="email"
              placeholder={intl.formatMessage({ id: 'login.emailPlaceholder' })}
              required
              disabled={isPending}
            />
          </div>

          <Button
            htmlType="submit"
            type={ButtonType.Primary}
            className="login-submit"
            loading={isPending}
            loadingText={intl.formatMessage({ id: 'login.submitSending' })}
          >
            <FormattedMessage id="login.submitButton" />
          </Button>
        </form>

        <Link to={'/sign-up'} className="link">
          <FormattedMessage id="login.signUpLink" />
        </Link>

        <p className="support">
          <FormattedMessage id="login.support" />{' '}
          <span className="bold">ritabygglov@gmail.com</span>
        </p>

        <Alert alert={state.alert} />
      </div>
    </div>
  );
}

export default Login;
